import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { RoomManagerService } from '../room/room-manager.service';
import { ReplayerService, OnReplayer } from '../../player/replayer.service';
import { PermissionsParserService } from '../permissions/permissions-parser.service';
import { IPermissionsManager } from '../permissions/permissions-manager';

import { RecordingManagerService } from '../recording/recording-manager.service';

@Injectable()
export class PermissionsManagerService implements IPermissionsManager {
	constructor(private parser: PermissionsParserService, private recordingManagerService: RecordingManagerService) {
		parser.setManager(this);
	}
	permissionUseTools = false
	useTools(use) {
		this.permissionUseTools = use;
	}
	canUseTools() {
		return this.permissionUseTools ||this.recordingManagerService.allowRecording;
	}
	sendUseTools(to, use){
		this.parser.sendUseTools(to, use);
	}
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/permissions/permissions-manager.service.ts